import axios from "axios";
const CancelToken = axios.CancelToken;

import { disableReactDevTools } from '@fvilers/disable-react-devtools';

require('dotenv').config();

const Cryptr = require('cryptr');

import { JSEncrypt } from "jsencrypt";

//import { AppConfiguration } from "read-appsettings-json";
//let hostServer = {};

//hostServer = AppConfiguration.Setting().HostServer;

import configData from "./config.json"

// Disable console.log on Production Environment
// if (process.env.NODE_ENV === "production")
if (window._CONSOLE_LOG == "false" && process.env.NODE_ENV === "production" ) {
    console.log = () => { };
    disableReactDevTools();
    // manage at development ENV
} else if (process.env.REACT_APP_CONSOLE_LOG === "false" && process.env.NODE_ENV === "development") {
    console.log = () => { };
}


console.log("hostserver Win: " + window._HOSTSERVER_CONFIG)
console.log("port Win: " + window._HOSTPORT_CONFIG)
console.log("CONSOLE_LOG: " + window._CONSOLE_LOG)


let hostServerConfig = {
    "name": "",
    "port": ""
}

if (process.env.NODE_ENV === "development") {
    console.log("development server", `${process.env.REACT_APP_URL_DEVELOPMENT}`);
} else {
    console.log("Reading SERVER:PORT from config.js");
    if (window._HOSTSERVER_CONFIG !== undefined && window._HOSTPORT_CONFIG !== undefined) {
        const cryptr = new Cryptr('1wertQSCFTBer%gh&hj/()KJHHGHGH*#');
        hostServerConfig.name = cryptr.decrypt(window._HOSTSERVER_CONFIG);
        hostServerConfig.port = cryptr.decrypt(window._HOSTPORT_CONFIG);
    } else {
        hostServerConfig.name = "Can't read server name";
        hostServerConfig.port = "Can't read server port number";
    }
}

//console.log("Config server: ", hostServerConfig);

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    //console.log(config);
    return config;
}, function (error) {
    // Do something with request error
    console.log("request error...");
    if (process.env.NODE_ENV === "development" ) 
        return Promise.reject(error);
    else 
        return Promise.reject("Request error");
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
    
    const status = error.response ? error.response.status : null

    if (status === 401) { 
        console.log("Refresh token is not valid. Please login again");
        return error.response;
    } 

    if (!status) {
        console.log("Error: Network Error accessing BE server. Maybe it's not running");
        return error.response;
    }
     console.log(error);
    
    
    console.log("response error");
    if (process.env.NODE_ENV === "development")
        return Promise.reject(error);
    else
        return Promise.reject("response error");
    
});



export const buildSource = () => CancelToken.source();

export const apiCall = (method, path, data, accesstoken, cancelCallback) => {

    const url = (process.env.NODE_ENV === "development") ?
        `${process.env.REACT_APP_URL_DEVELOPMENT}${path}` :
        `${hostServerConfig.name}:${hostServerConfig.port}${path}`;
    
    console.log("URL:", url);

    return axios({
        method,
        url,
        data,
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'Authorization': 'Bearer ' + accesstoken,
        },
        cancelToken: cancelCallback && typeof cancelCallback === "function" && new CancelToken(cancelCallback)
    }).catch(function (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        console.log(error.config);
    });

};

export const apiCallGetArrayBuffer = (method, path, data, accesstoken, cancelCallback) => {

    const url = (process.env.NODE_ENV === "development") ?
        `${process.env.REACT_APP_URL_DEVELOPMENT}${path}` :
        `${hostServerConfig.name}:${hostServerConfig.port}${path}`;

    console.log("URL:", url);

    return axios({
        method,
        url,
        data,
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'Authorization': 'Bearer ' + accesstoken,
        },
        responseType: 'arraybuffer',
        cancelToken: cancelCallback && typeof cancelCallback === "function" && new CancelToken(cancelCallback)
    }).catch(function (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        console.log(error.config);
    });

};

export const login = async (username1, password1) => {
    try {

        console.log(username1, password1);
        // 1. key = Call cryptaus avain  
        var encrypt = new JSEncrypt();
        const publicKey = await apiCall("get", "/public_key", {}, "")
            .then((result) => {
                console.log(result);
                //await getLoggedIn();
                //history.push("/player");
                return result;
            })
            .catch(err => {
                console.log(err)
            });

        if (typeof publicKey === 'undefined') {
            return null;
        }
            

        console.log(publicKey.data);
        encrypt.setPublicKey(publicKey.data);

        //new_name = rsa_javascript ( name)
        let username = encrypt.encrypt(username1);
        console.log("encrypted_name",username);

        //new_password = rsa_javascript(password);
        let password = encrypt.encrypt(password1);
        console.log("encrypted_password",password);

        // crypted return false
        if (!username || !password)
            return null;

        const result = await apiCall("post", "/login_vr", { username, password }, "");
        
        console.log(result.data);
        return result.data;
        //return constLogin;
    } catch (e) {
        // eslint-disable-next-line
        //console.log("error", e.message);
        console.log("error", e.message)
    }
};